import { Navigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useAuthState } from './useAuthState';

/** Shows the page only when signed in; otherwise sends you to setup or sign-in. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const state = useAuthState();

  if (state.isPending) {
    return (
      <main className="page">
        <section className="card" role="status" data-state="loading">
          <p className="card-title">Loading…</p>
        </section>
      </main>
    );
  }
  if (state.isError) {
    return (
      <main className="page">
        <section className="card card-bad" role="status" data-state="unreachable">
          <p className="card-title">Can't reach the server</p>
          <button type="button" onClick={() => void state.refetch()}>
            Try again
          </button>
        </section>
      </main>
    );
  }
  if (!state.data.signedIn) {
    return <Navigate to={state.data.ownerExists ? '/sign-in' : '/setup'} replace />;
  }
  return <>{children}</>;
}
